/* Représente une priorité dans servicentre.. */
export class PriorityCode {
  public idPriorite?: number = undefined;

  public description?: string = '';

  public codeCouleur?: string = '';
}
